import { Heart, Users, Globe, Shield, Award } from 'lucide-react';

export default function AboutPage() {
  return (
    <div className="min-h-screen py-24 md:py-32 bg-background" data-testid="about-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm font-medium tracking-wider uppercase text-primary mb-3 block">Notre histoire</span>
          <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">À propos de M-CareLink</h1>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Une conviction profonde : chacun mérite de pouvoir partir en vacances, quelle que soit sa situation.
          </p>
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 border border-border/30 shadow-sm mb-12">
          <h2 className="font-heading text-2xl font-semibold mb-4">Notre mission</h2>
          <p className="text-muted-foreground leading-relaxed mb-6">
            M-CareLink est née d'un constat simple et douloureux : des millions de proches aidants renoncent chaque année à partir en vacances, faute de solutions réellement adaptées. Entre la difficulté de trouver un hébergement accessible, la peur d'une rupture d'accompagnement et la complexité logistique, le renoncement devient la norme.
          </p>
          <p className="text-muted-foreground leading-relaxed">
            Notre mission est de changer cela en créant un guichet unique de coordination qui simplifie radicalement l'organisation de séjours de répit adaptés. Nous mettons en relation les dyades aidant-aidé avec un réseau de partenaires qualifiés et coordonnons l'ensemble des prestations pour garantir un séjour serein, sécurisé et digne.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {[
            { icon: Heart, title: "Humanité", desc: "Chaque situation est unique. Nous prenons le temps de comprendre et d'adapter nos services à chaque besoin." },
            { icon: Shield, title: "Rigueur", desc: "Nos partenaires sont évalués selon des critères stricts. La qualité et la sécurité sont au centre de notre approche." },
            { icon: Users, title: "Inclusion", desc: "Nous croyons que les vacances sont un droit pour tous, indépendamment du niveau d'autonomie ou de mobilité." },
            { icon: Globe, title: "Innovation", desc: "Nous développons une plateforme unique qui combine coordination care, travel et accompagnement médico-social." }
          ].map(({ icon: Icon, title, desc }) => (
            <div key={title} className="flex gap-4 p-6 bg-white rounded-2xl border border-border/30">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon className="w-6 h-6 text-primary" />
              </div>
              <div>
                <h3 className="font-heading text-lg font-semibold mb-1">{title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-primary text-primary-foreground rounded-3xl p-8 md:p-12 text-center">
          <Award className="w-12 h-12 mx-auto mb-4 text-accent" />
          <h2 className="font-heading text-2xl font-semibold mb-3">Notre vision</h2>
          <p className="text-primary-foreground/80 leading-relaxed max-w-2xl mx-auto">
            Devenir la plateforme de référence pour la coordination de séjours de répit adaptés en France, en créant un écosystème vertueux entre aidants, partenaires professionnels et organismes prescripteurs.
          </p>
        </div>
      </div>
    </div>
  );
}
